import { combineReducers, Action, Reducer } from "@reduxjs/toolkit";

import { appVersionSlice } from "./appVersion/slice";
import { fixedAssetRegisterSlice } from "./fixedAsset";
import { insightsSlice } from "./insights";
import storage from "redux-persist/lib/storage";

import { authSlice } from "@/redux/auth/index";
import { clientDirectorySlice } from "@/redux/clientDirectory";
import { clientSettingsSlice } from "@/redux/clientSettings";
import { complianceCalendarSlice } from "@/redux/complianceCalendar";
import { disbursementsSlice } from "@/redux/disbursements";
import { expenseManagementSlice } from "@/redux/expenseManagement";
import { fileManagerSlice } from "@/redux/fileManager";
import { gstModuleSlice } from "@/redux/gstModule";
import { helpModuleSlice } from "@/redux/helpModule";
import { hrmsSlice } from "@/redux/hrms";
import { insightAdvanceSlice } from "@/redux/insightsAdvanced";
import { invoiceGenerationSlice } from "@/redux/invoiceGeneration";
import { invoicingSlice } from "@/redux/invoicing/slice";
import { invoicingAdvanceSlice } from "@/redux/invoicingAdvance";
import { jobsSlice } from "@/redux/jobs";
import { listingSlice } from "@/redux/listing/slice";
import { maintenanceSlice } from "@/redux/maintenance/slice";
import { masterDataSlice } from "@/redux/masterData";
import { mySpaceSlice } from "@/redux/mySpace/slice";
import { notificationSlice } from "@/redux/notification/slice";
import { openItemsSlice } from "@/redux/openItems/slice";
import { reportsSlice } from "@/redux/reports";
import { schedulingSlice } from "@/redux/scheduling/slice";
import { servicesSlice } from "@/redux/services/slice";
import { sopModuleSlice } from "@/redux/sopModule";
import { stcoToolsSlice } from "@/redux/stcoTools";
import { supportSlice } from "@/redux/support";
import { tdsTcsManagementSlice } from "@/redux/tdsTcsManagement";
import { thinksToDoSlice } from "@/redux/thinksToDo";
import { timeSheetSlice } from "@/redux/timeSheet/slice";
import { userManagementSlice } from "@/redux/userManagement/slice";
import { usersProfileSlice } from "@/redux/usersProfile";

const reducers = combineReducers({
  services: servicesSlice.reducer,
  auth: authSlice.reducer,
  invoicing: invoicingSlice.reducer,
  listing: listingSlice.reducer,
  insights: insightsSlice.reducer,
  insightsAdvanced: insightAdvanceSlice.reducer,
  openItems: openItemsSlice.reducer,
  fileManager: fileManagerSlice.reducer,
  clientSettings: clientSettingsSlice.reducer,
  invoiceGeneration: invoiceGenerationSlice.reducer,
  reports: reportsSlice.reducer,
  userManagement: userManagementSlice.reducer,
  stcoTools: stcoToolsSlice.reducer,
  maintenance: maintenanceSlice.reducer,
  disbursements: disbursementsSlice.reducer,
  gst: gstModuleSlice.reducer,
  clientDirectory: clientDirectorySlice.reducer,
  masterData: masterDataSlice.reducer,
  timeSheet: timeSheetSlice.reducer,
  usersProfile: usersProfileSlice.reducer,
  jobs: jobsSlice.reducer,
  complianceCalendar: complianceCalendarSlice.reducer,
  helpModule: helpModuleSlice.reducer,
  scheduling: schedulingSlice.reducer,
  notification: notificationSlice.reducer,
  fixedAssetRegister: fixedAssetRegisterSlice.reducer,
  mySpace: mySpaceSlice.reducer,
  hrms: hrmsSlice.reducer,
  sopModule: sopModuleSlice.reducer,
  thinksToDo: thinksToDoSlice.reducer,
  expenseManagement: expenseManagementSlice.reducer,
  support: supportSlice.reducer,
  invoicingAdvance: invoicingAdvanceSlice.reducer,
  appVersion: appVersionSlice.reducer,
  tdsTcsManagement: tdsTcsManagementSlice.reducer,
});

export type RootState = ReturnType<typeof reducers>;

export const rootReducer: Reducer<RootState, Action> = (state, action) => {
  // Reset redux state and persist on logout
  if (action.type === "USER_LOGOUT") {
    storage.removeItem("persist:root");
    return reducers(undefined, action);
  }

  return reducers(state, action);
};
